import { useEffect, useState } from 'react';

const useDeviceType = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const [isTablet, setIsTablet] = useState(
		window.innerWidth <= 1024 && window.innerWidth > 768,
	);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
			setIsTablet(window.innerWidth <= 1024 && window.innerWidth > 768);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { isMobile, isTablet };
};

export default useDeviceType;
